import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import {
  AUTH_TYPES,
  AUTH_USER_TYPES,
  HELPER_TYPES,
  STORE_TYPES,
} from "../store/types";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: () => import("../views/dashboard/Index.vue"),
    meta: {
      requiresAdmin: true,
      isLoggedIn: true,
    },
  },
  {
    path: "/course/:id",
    name: "CourseShow",
    component: () => import("../views/course/Index.vue"),
    meta: {
      requiresAdmin: true,
      isLoggedIn: true,
    },
  },
  // {
  //     path: "/watch",
  //     name: "Watch",
  //     component: Watch,
  //     meta: {
  //         isLoggedIn: true,
  //     },
  // },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/profile/Index.vue"),
    meta: {
      requiresAdmin: true,
      isLoggedIn: true,
    },
  },
  {
    path: "/documents",
    name: "Documents",
    component: () => import("../views/documents/Index.vue"),
    meta: {
      requiresAdmin: true,
      isLoggedIn: true,
    },
  },

  {
    path: "/coupons",
    name: "Coupons",
    component: () => import("../views/coupons/Index.vue"),
    meta: {
      requiresAdmin: true,
      isLoggedIn: true,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/settings/Index.vue"),
    meta: {
      requiresAdmin: true,
      isLoggedIn: true,
    },
  },
  {
    path: "/lecturer-dashboard",
    name: "LecturerDashboard",
    component: () => import("../views/lecturerDashboard/Index.vue"),
    meta: {
      requiresAdmin: true,
      isLoggedIn: true,
    },
  },

  {
    path: "/login",
    name: "Login",
    component: () => import("../views/auth/Login.vue"),
    meta: {
      isLoggedIn: false,
    },
  },
  {
    path: "/login/:token",
    name: "LoginWithToken",
    component: () => import("../views/auth/Login.vue"),
    meta: {
      isLoggedIn: true,
    },
  },
  {
    path: "/password-reset",
    name: "PasswordReset",
    component: () => import("../views/auth/PasswordReset.vue"),
    meta: {
      isLoggedIn: false,
    },
  },
  {
    path: "/password-change/:token",
    name: "PasswordChange",
    component: () => import("../views/auth/PasswordChange.vue"),
    meta: {
      isLoggedIn: false,
    },
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async (to, from, next) => {
  store.dispatch(`${STORE_TYPES.HELPERS}/${HELPER_TYPES.RESET_DATA}`);

  const isLoggedIn =
    store.getters[`${STORE_TYPES.AUTH}/${AUTH_TYPES.IS_LOGGED_IN}`];

  const routeRequiresLogIn = to.matched.some(
    (record) => record.meta.isLoggedIn
  );
  if (to.name == "LoginWithToken") {
    const loginToken = to.params.token;
    if (loginToken) {
      const loginSucceeded = await store.dispatch(
        `${STORE_TYPES.AUTH}/${AUTH_TYPES.LOGIN_WITH_TOKEN}`,
        { token: loginToken }
      );
      if (loginSucceeded) {
        next({ name: "Dashboard" });
        return;
      }
    }
  }

  const authUser =
    store.getters[`${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`];
  if ((from.matched.length == 0 || authUser == null) && isLoggedIn) {
    await store.dispatch(
      `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.FETCH_USER}`
    );
  }

  if (!authUser.is_lecturer && to.name?.includes("LecturerDashboard")) {
    next({ name: "Dashboard" });
    return;
  }

  if (to.name == null) {
    next({ name: "Login" });
    return;
  } else if (!isLoggedIn && routeRequiresLogIn) {
    next({ name: "Login" });
    return;
  } else if (isLoggedIn && !routeRequiresLogIn) {
    next({ name: "Dashboard" });
    return;
  }
  next();
});

export default router;
